<template>
  <div>
    <h3>Отсканировано стекол с начала месяца</h3>
    <p class="text-xs-right" v-if="data.lastUpdate"><i class="fas fa-clock"></i> {{ data.lastUpdate }}</p>
    <v-data-table
      :headers="headers"
      :items="data.data"
      :loading="data.inProgress"
      :hide-actions="true"
      no-data-text="Статистика недоступна"
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <tr>
          <td>{{ props.item.date }}</td>
          <td><b>{{ props.item.count }}</b></td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'GlassesScanned',
  props: {
    data: {
      Type: Object
    }
  },
  data () {
    return {
      headers: [
        {
          text: 'Дата',
          align: 'left',
          sortable: false,
          value: 'date',
          width: '80px'
        },
        {
          text: 'Количество',
          sortable: false,
          value: 'count',
          width: '50px'
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Walldash/GlassesScanned.vue